'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _frontendUtils = require('@import/frontend-utils');
var _validationUtils = require('@import/validation-utils');
var ValidationUtils = _interopRequireWildcard(_validationUtils);
var _BaseApi = require('../BaseApi');
var _BaseApi2 = _interopRequireDefault(_BaseApi);
var _ParameterError = require('../ParameterError');
var _ParameterError2 = _interopRequireDefault(_ParameterError);
var _ObjectStoreBaseApi = require('./ObjectStoreBaseApi');
var _ObjectStoreBaseApi2 = _interopRequireDefault(_ObjectStoreBaseApi);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var UserApi = function () {
  function UserApi() {
    (0, _classCallCheck3.default)(this, UserApi);
    this.apiService = new _BaseApi2.default(_frontendUtils.endpoints.apiBaseUrl);
    this.storeService = new _ObjectStoreBaseApi2.default(_frontendUtils.endpoints.apiBaseUrl, 'user');
  }

  /**
   * Obtains list of users searching by the username.
   * @param  {[String]} userNames Array containing user names.
   * @return {Promise}            Promise resolves if request finishes successfully. Otherwise promise rejects with ParameterError or ResponseError.
   */

  (0, _createClass3.default)(UserApi, [{
    key: 'getUsersByNames',
    value: function getUsersByNames(userNames) {
      if (!ValidationUtils.isArrayOf(ValidationUtils.isNonEmptyOrBlankString, userNames)) {
        return Promise.reject(new _ParameterError2.default('userNames', userNames, 'array of non-blank strings.'));
      }
      return this.storeService.searchAllBatch({
        q: '(fields:(username:(' + userNames.join(' OR ') + ')))'
      });
    }

    /**
     * Checks if an account is registered for a given email address.
     * @param  {String} email Email address to check.
     * @return {Promise}      Resolves, if successful, to an object with fields for providers (social sign in) and password. Otherwise returns an error.
     */
  }, {
    key: 'userAuthInfo',
    value: function userAuthInfo(email) {
      if (!ValidationUtils.isUndefinedOr(ValidationUtils.isNonEmptyOrBlankString, email)) {
        return Promise.reject(new _ParameterError2.default('email', email, 'non-blank string.'));
      }
      return this.storeService.makeRequest({
        method: 'GET',
        url: '/_oauth/connections',
        queryParameters: {
          username: email
        }
      });
    }
    /**
     * Checks providers.
     * @return {Promise}      Resolves, if successful, to an object with fields for providers (social sign in).
     */
  }, {
    key: 'getProviders',
    value: function getProviders() {
      return this.storeService.makeRequest({
        method: 'GET',
        url: '/_oauth/providers'
      });
    }
    /**
     * Removes provider.
     * @return {Promise}      Resolves, if successful, to remove the provider from the user.
     */
  }, {
    key: 'removeProvider',
    value: function removeProvider(provider) {
      return this.storeService.makeRequest({
        method: 'DELETE',
        url: '/_oauth/connection/' + provider
      });
    }
    /**
     * Deletes account.
     * @param  {String} uid of the user to delete.
     * @return {Promise}      Resolves, if successful, to delete user account.
     */
  }, {
    key: 'deleteAccount',
    value: function deleteAccount(guid) {
      return this.storeService.makeRequest({
        method: 'DELETE',
        url: '/' + guid
      });
    }
    /**
     * Change email of account
     * @param guid {String} guid of user.
     * @param email {String} new email of user.
     * @return {Promise}      Resolves, if successful, emaikl account changed.
     */
  }, {
    key: 'changeEmail',
    value: function changeEmail(guid, email) {
      return this.storeService.update(guid, {
        email: email
      });
    }
    /**
     * Change email of account
     * @param guid {String} guid of user.
     * @param email {String} new username of user.
     * @return {Promise}      Resolves, if successful, emaikl account changed.
     */
  }, {
    key: 'changeUsername',
    value: function changeUsername(guid, username) {
      return this.storeService.update(guid, {
        username: username
      });
    }
  }, {
    key: 'getUserData',
    value: function getUserData() {
      var userGuid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return this.apiService.makeRequest({
        method: 'GET',
        url: 'user/data/' + userGuid
      });
    }
  }, {
    key: 'updateUserPreferences',
    value: function updateUserPreferences(value) {
      return this.apiService.makeRequest({
        url: 'user/preferences',
        method: 'PATCH',
        body: value
      });
    }
  }]);
  return UserApi;
}();
exports.default = UserApi;